import { render } from "./DiseaseList.vue?vue&type=template&id=21a37870&scoped=true&ts=true"
import script from "./DiseaseList.vue?vue&type=script&lang=ts"
export * from "./DiseaseList.vue?vue&type=script&lang=ts"

import "./DiseaseList.vue?vue&type=style&index=0&id=21a37870&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a37870"]])

export default __exports__